export const scrollToCenterNav = () => {
  // Adobe Fontsが読み込まれてからでないと、スクロール位置がずれるため
  const executeScroll = () => {
    if (document.documentElement.classList.contains('wf-active')) {
      const nav = document.getElementById('js-header-nav');
      const currentItem = nav?.querySelector('._current');
      currentItem?.scrollIntoView({ inline: 'center' });
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      observer.disconnect();
    }
  };

  const observer = new MutationObserver(executeScroll);

  observer.observe(document.documentElement, {
    attributes: true,
  });
};
